module.exports = __webpack_public_path__ + "img/TimeBar.745d0871.png";